import React from 'react';

const TimeTable = ({ weekDates, currentTimeSheet }: any) => {
  const report = currentTimeSheet.report;

  const totalAmount = function (data: any, day: any) {
    const mydata = data.map((cat: any) => {
      return cat.timeValues[day].hours;
    });
    var totalSum = 0;
    for (var i = 0; i < mydata.length; i++) {
      if (mydata[i] !== '') {
        totalSum += mydata[i];
      }
    }
    return totalSum;
  };

  let dailyTotal = [];
  for (let i = 0; i < 5; i++) {
    dailyTotal.push(totalAmount(report, i));
  }

  return (
    <div className='p-4'>
      <div>
        <table className='table-fixed border-collapse border border-gray-400'>
          <thead>
            <tr className='text-primary'>
              <th className='w-3/12 border-collapse border border-gray-300'>
                Category
              </th>
              <th className='w-4/12  border-collapse border border-gray-300'>
                Description
              </th>
              {weekDates.map((myDate: any) => {
                return (
                  <th
                    key={myDate.day}
                    className='w-1/12 p-2  border-collapse border border-gray-300'
                  >
                    <p>{myDate.date}</p>
                    <p>{myDate.day}</p>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {report.map((myReport: any, idx: any) => {
              return (
                <tr className='text-center' key={idx}>
                  <td className='py-3 border-collapse border border-gray-300 text-primary'>
                    {myReport.eventCode}
                  </td>
                  <td className='py-3 border-collapse border border-gray-300'>
                    {myReport.description}
                  </td>
                  {myReport.timeValues.map((hour: any, index: any) => {
                    return (
                      <td
                        key={index}
                        className='py-3 border-collapse border border-gray-300'
                      >
                        {hour.hours}
                      </td>
                    );
                  })}
                </tr>
              );
            })}

            <tr className=''>
              <td></td>
              <td className='text-primary'>
                Total Hours = {dailyTotal.reduce((sum, a) => sum + a, 0)}/40
              </td>
              {dailyTotal.map((hour, idx) => {
                return (
                  <td
                    key={idx}
                    className='py-3 text-center border-collapse border border-gray-300'
                  >
                    {hour}
                  </td>
                );
              })}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TimeTable;
